const collegeIntroP1 = '2019年，一个全新的市场-信创产业开始进入了大家的视野。2020年，各地信创项目开始大面积铺开，信创产业也随之出现了一个现象级风口。与此同时，和信创产业相关的生态体系，包括开源软件、业务应用、安全防护等，也成为业界关注的焦点。 作为基础软件，操作系统在IT产业中关系重大，统信桌面操作系统UOS资助研发比例持续提高，目前围绕其打造的自主软件生态已经具备良好成效。统信软件将继续加大与国内优秀软硬件厂商的合作，携手共建信息技术应用创新的新生态圈。在未来信息技术领域的发展路径上要形成中国的话语权和优势。'
const collegeIntroP2 = ' 统信软件教育与考试中心作为统信软件的重要组成部分，承担了基于统信UOS操作系统构建完整开源培训体系的重任。自2020年4月开始进行外部培训，截止目前，参加培训的单位3300余家，培训人员400000人次，累计颁发各类证书40000张。 从业多年的金牌讲师，独创的课程体系以及全方位立体化的培训方式，还有特别定制的针对不同机构人群的培训，2种认证体系和高含金量的证书。统信软件开启了为国产操作系统培养高精尖人才的新旅程。 心若在，梦就在，只为那些期待的眼神，再苦再难也要坚持，为了国产软件崛起的日子。'
const advantage = [
    {
        advanTitle:"信创背景",
        advanDescription:"统信软件定位信创基础软件，是基础中的基础，核心中的核心，在国家的整体信创布局上，具有重要的战略意义。"
    },
    {
        advanTitle:"市场缺口大",
        advanDescription:"目前统信软件在信创市场占有率非常高，但是认证体系刚刚开始推广，相关适配人员、运维人员、研发人员和产品人员的缺口极大。"
    },
    {
        advanTitle:"双重认证",
        advanDescription:"技术认证盖工信人才和统信软件的双章，在工信人才官网和统信软件官网都可以查询。目前操作系统厂商只有统信拥有双章认证。"
    },
    {
        advanTitle:"更务实",
        advanDescription:"技术认证从初级到高级全部采用上机实操的方式，目前只有红帽和我们可做到，相对传统ABCD考理论的认证，更注重实用性，更务实。"
    },
    {
        advanTitle:"提升学生信创就业力",
        advanDescription:"未来几年，随着党政操作系统的国产化，金融、法律、能源等行业的操作系统也将逐渐国产化，办公使用的电脑也将预装统信UOS，财会、法律、能源等专业的学生考取统信认证对于后期就业有极大促进。"
    },
    {
        advanTitle:"完善的技术支持体系",
        advanDescription:"统信软件教育与考试中心提供长期全面的视频、文档、实验手册、试验环境和考试系统等，定期组织代理商师资培训，提升代理商技术水平，协助代理商开展长套、短套和定置化课程培训。"
    },
]
let seridata = [
    { name: "北京", company: [], value:0, postCode:'110000' },
    { name: "天津", company: [], value:0, postCode:'120000' },
    { name: "上海", company: [], value:0, postCode:'310000' },
    { name: "重庆", company: [], value:0, postCode:'500000' },
    { name: "河北", company: [], value:0, postCode:'130000' },
    { name: "河南", company: [], value:0, postCode:'410000' },
    { name: "云南", company: [], value:0, postCode:'530000' },
    { name: "辽宁", company: [], value:0, postCode:'210000' },
    { name: "黑龙江", company: [], value:0, postCode:'230000' },
    { name: "湖南", company: [], value:0, postCode:'430000' },
    { name: "安徽", company: [], value:0, postCode:'340000' },
    { name: "山东", company: [], value:0, postCode:'370000' },
    { name: "新疆", company: [], value:0, postCode:'650000' },
    { name: "江苏", company: [], value:1, postCode:'320000' },
    { name: "浙江", company: [], value:0, postCode:'330000' },
    { name: "江西", company: [], value:0, postCode:'360000' },
    { name: "湖北", company: [], value:0, postCode:'420000' },
    { name: "广西", company: [], value:0, postCode:'450000' },
    { name: "甘肃", company: [], value:0, postCode:'620000' },
    { name: "山西", company: [], value:0, postCode:'140000' },
    { name: "内蒙古", company: [], value:0, postCode:'150000' },
    { name: "陕西", company: [], value:1, postCode:'610000' },
    { name: "吉林", company: [], value:0, postCode:'220000' },
    { name: "福建", company: [], value:1, postCode:'350000' },
    { name: "贵州", company: [], value:0, postCode:'520000' },
    { name: "广东", company: [], value:1, postCode:'440000' },
    { name: "青海", company: [], value:0, postCode:'630000' },
    { name: "西藏", company: [], value:0, postCode:'540000' },
    { name: "四川", company: [], value:0, postCode:'510000' },
    { name: "宁夏", company: [], value:1, postCode:'640000' },
    { name: "海南", company: [], value:1, postCode:'460000' },
    { name: "台湾", company: [], value:0, postCode:'710000' },
    { name: "香港", company: [], value:0, postCode:'810000' },
    { name: "澳门", company: [], value:0, postCode:'820000' },
    { name: "南海诸岛", company: [], value:0, postCode:''},
  ]
export {collegeIntroP1,collegeIntroP2,advantage,seridata}